import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {operationsSelector, rowSelector} from "../periodValuesFilterApi";
import {Button, Label, Pane, SelectField} from "evergreen-ui";
import {findFirstByCode, findFirstByName} from "./matchMethods";
import {
    getCodesByStationAndDatasourceType,
    getEntitiesByStationAndDatasourceTypeId
} from "../decadeConstructor/ApiCalls";

export default function FilterRow({
        constructor,
        rowId,
        isFullInfo,
        filters,
        selectOperationFilterAction,
        deleteFilterAction,
        selectFilterDatasourceTypeAction,
        selectEntityAction,
        selectFilterCodeAction,
}) {
    const dispatch = useDispatch();

    const withOperation = !(selectOperationFilterAction == undefined)
    const withCode = !(selectFilterCodeAction == undefined)

    const operations   = useSelector(operationsSelector);


    const row = useSelector(state => rowSelector(state, filters, rowId));

    const isStationSet = constructor.station.id !== -1
    const isTypeSet = row.type.id !== -1
    const isCodeSet = row.code === undefined ? false : row.code.id !== -1

    const inner_codes = row.type.codes === undefined ? [] : row.type.codes.length !== 0 ? row.type.codes : []

    const inner_dsources_types = constructor.station.sourcesTypes.length != 0 ? constructor.station.sourcesTypes : []
    const [possibleCodes, setPossibleCodes] = React.useState(inner_codes)

    const possibleEntities = row.code.entities === undefined || row.code.entities === null ? [] : row.code.entities

    const rowNum = filters.findIndex((el) => el.rowId === row.rowId) + 1

    function handleStationEnt(selectedItem) {
        let res = findFirstByName(possibleEntities, selectedItem)

        dispatch(selectEntityAction({res, rowId}))
    }

    function handleOperation(selectedItem) {
        const res = selectedItem;

        dispatch(selectOperationFilterAction({res, rowId}));
    }

    function handleCode(selectedItem) {
        let res = findFirstByCode(possibleCodes, selectedItem.code)

        getEntitiesByStationAndDatasourceTypeId(constructor.station.id, row.type.id).then((result) => {
            res = {id: res.id, code: res.code, entities: result.data}
            dispatch(selectFilterCodeAction({res, rowId}));
        })
    }

    function handleDatasourceType(name) {
        let res = findFirstByName(inner_dsources_types, name)

        getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((result) => {
            setPossibleCodes(result.data)
            res = {id: res.id, name: res.name, codes: result.data}
            dispatch(selectFilterDatasourceTypeAction({res, rowId}))
        })
    }

    function onDeleteAction(rowId) {
        dispatch(deleteFilterAction({rowId}))
    }

    return (
        <Pane marginBottom={4} alignItems={"top"}>
            <Pane display="flex" columnGap={25} >
                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Тип источника"}
                        onChange={x => handleDatasourceType(x.target.value)}
                        value={row.type.name}
                        disabled={isFullInfo || !isStationSet}
                        width={290}
                        marginTop={-4.5}
                    >
                        <option value={-1}>Выберите тип источника</option>
                        {inner_dsources_types.map((type, idx) => <option key={type.name} value={type.name}>{type.name}</option>)}
                    </SelectField>
                </Pane>

                {
                    withCode?
                        <>
                            <Label marginTop={25} width={30} htmlFor="codeAutocomplete">
                                K-{rowNum}
                            </Label>
                            <Pane verticalAlign={"top"}>
                                <SelectField
                                    label={"Метеокод"}
                                    onChange={x => handleCode({id: x.target.key, code: x.target.value})}
                                    value={row.code.code}
                                    disabled={isFullInfo || !isTypeSet}
                                    width={220}
                                    marginTop={-4.5}
                                >
                                    <option value={-1}>Выберите метеокод</option>
                                    {
                                        isFullInfo ? <option value={row.code.code}>{row.code.code}</option>
                                            : possibleCodes.map((code) => <option key={code.id} value={code.code}>{code.code}</option>)
                                    }
                                </SelectField>
                            </Pane>
                        </>
                         : ''
                }

                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Пункт наблюдения"}
                        onChange={x => handleStationEnt(x.target.value)}
                        value={row.stnEntity == null || row.stnEntity === undefined ? -1 : row.stnEntity.name}
                        disabled={isFullInfo || !isCodeSet}
                        width={180}
                        marginTop={-4.5}
                    >
                        <option value={-1}>Выберите пункт наблюдения</option>
                        {
                            isFullInfo ?
                                row.stnEntity == null || row.stnEntity == undefined ? <option value={-1}>Не выбрана</option> :
                                <option value={row.stnEntity.name}>{row.stnEntity.name + " " + row.stnEntity.valueParamsString}</option> :
                                possibleEntities.filter((ent) => ent.typeCode !== "DEVICE")
                                    .map((ent) => <option key={ent.name} value={ent.name}>{ent.name + " " + ent.valueParamsString}</option>)
                        }
                    </SelectField>
                </Pane>

                {
                    withOperation?
                        <Pane verticalAlign={"top"}>
                            <SelectField
                                label={"Операция"}
                                onChange={x => handleOperation(x.target.value)}
                                value={row.operation}
                                disabled={isFullInfo  || !isCodeSet }
                                width={180}
                                marginTop={-4.5}
                            >
                                <option value={-1}>Выберите операцию</option>
                                {operations.map(({code, name}) => <option key={code} value={code}>{name}</option>)}
                            </SelectField>
                        </Pane> : ''
                }

                {
                    rowId === 0 || isFullInfo ? '' : <Button alignSelf={"center"} marginBottom={6} onClick={x => onDeleteAction(rowId)}>Удалить</Button>
                }
            </Pane>
        </Pane>
    );
}
